import {
  ArtistNameDesk,
  ArtistNameMobile,
  EventDesk,
  EventMobile,
  Formula1Desk,
  MLBDesk,
  MLBMobile,
  MLSDesk,
  NBADesk,
  NBAMobile,
  NFLDesk,
  NFLMobile,
  NHLDesk,
  NHLMobile,
  NascarDesk,
  PGADesk,
  PGAMobile,
  UFCDesk,
} from '@assets/leagues';
import { GetEventsType } from '@interfaces/APITravel';
import Image from 'next/legacy/image';
import { FC } from 'react';
import classes from './styles.module.scss';

export type HeadingSlugProps =
  | 'mlb'
  | 'mlb-spring-training'
  | 'nba'
  | 'nfl'
  | 'nhl'
  | 'pga'
  | 'formula-1'
  | 'nascar'
  | 'ufc'
  | 'mls'
  | 'artist'
  | 'ncaa-mens-basketball'
  | 'ncaa-mens-football'
  | 'wnba'
  | 'tennis'
  | 'wwe'
  | 'pwhl'
  | 'cfl'
  | 'rodeo'
  | 'world-cup'
  | 'super-bowl'
  | 'pro-bowl'
  | 'premier-league'
  | 'la-liga'
  | 'serie-a'
  | 'bundesliga'
  | 'ligue-1'
  | GetEventsType;

export type SlugType<T> = Partial<{ [key in HeadingSlugProps]: T }>;

const images: SlugType<any> = {
  mlb: MLBDesk,
  'mlb-spring-training': MLBDesk,
  nba: NBADesk,
  'ncaa-mens-basketball': NBADesk,
  nfl: NFLDesk,
  'ncaa-mens-football': NFLDesk,
  nhl: NHLDesk,
  pga: PGADesk,
  mls: MLSDesk,
  nascar: NascarDesk,
  'formula-1': Formula1Desk,
  ufc: UFCDesk,
  wnba: NBADesk,
  tennis: NHLDesk,
  wwe: NFLDesk,
  pwhl: NHLDesk,
  cfl: NFLDesk,
  rodeo: NFLDesk,
  'world-cup': MLSDesk,
  'super-bowl': NFLDesk,
  'pro-bowl': NFLDesk,
  venues: ArtistNameDesk,
  performers: EventDesk,
};

const imagesMobile: SlugType<any> = {
  mlb: MLBMobile,
  'mlb-spring-training': MLBMobile,
  nba: NBAMobile,
  'ncaa-mens-basketball': NBAMobile,
  nfl: NFLMobile,
  'ncaa-mens-football': NFLMobile,
  nhl: NHLMobile,
  pga: PGAMobile,
  mls: MLSDesk,
  nascar: NascarDesk,
  'formula-1': Formula1Desk,
  ufc: UFCDesk,
  wnba: NBAMobile,
  tennis: NHLMobile,
  wwe: NFLMobile,
  pwhl: NHLMobile,
  cfl: NFLMobile,
  rodeo: NFLMobile,
  'world-cup': MLSDesk,
  'super-bowl': NFLMobile,
  'pro-bowl': NFLMobile,
  venues: ArtistNameMobile,
  performers: EventMobile,
};

export const formatTitle: SlugType<string> = {
  mlb: 'MLB Baseball Travel Packages',
  'mlb-spring-training': 'MLB Spring Training Travel Packages',
  nba: 'NBA Basketball Travel Packages',
  nfl: 'NFL Football Travel Packages',
  nhl: 'NHL Hockey Travel Packages',
  pga: 'PGA Golf Travel Packages',
  mls: 'MLS Travel Packages',
  'ncaa-mens-basketball': 'NCAA Mens Basketball Travel Packages',
  'ncaa-mens-football': 'NCAA Mens Football Travel Packages',
  nascar: 'NASCAR Travel Packages',
  'formula-1': 'Formula 1 Travel Packages',
  ufc: 'UFC Travel Packages',
  wnba: 'WNBA Travel Packages',
  tennis: 'Tennis Travel Packages',
  wwe: 'WWE Travel Packages',
  pwhl: 'PWHL Travel Packages',
  cfl: 'CFL Travel Packages',
  rodeo: 'Rodeo Travel Packages',
  'world-cup': 'World Cup Travel Packages',
  'super-bowl': 'Super Bowl Travel Packages',
  'pro-bowl': 'Pro Bowl Travel Packages',
  'premier-league': 'Premier League Travel Packages',
  'la-liga': 'La Liga Travel Packages',
  'serie-a': 'Serie A Travel Packages',
  bundesliga: 'Bundesliga Travel Packages',
  'ligue-1': 'Ligue 1 Travel Packages',
};

const LeagueHeading: FC<{ slug: HeadingSlugProps; title?: string }> = ({
  slug,
  title,
}) => {
  return (
    <>
      <div className={classes.headingImgDesk}>
        <div className={classes.imageWrapper}>
          <Image
            src={images[slug] ?? EventDesk}
            placeholder="blur"
            alt={slug}
          />
        </div>
      </div>
      <div className={classes.headingImgMobile}>
        <div className={classes.imageWrapper}>
          <Image
            src={imagesMobile[slug] ?? EventMobile}
            placeholder="blur"
            alt={slug}
          />
        </div>
      </div>
      <div className={classes.headingContent}>
        <h1 className={classes.headingTitle}>
          {title?.concat(' Travel Packages') ||
            `${formatTitle[slug]?.toUpperCase()}`}
        </h1>
      </div>
    </>
  );
};

export default LeagueHeading;
